<template>
  <div>
    <VerifyTyc />
    <div v-if="this.$store.state.tyc == 1">
      <verifyPromo />
    </div>
    <v-overlay :value="overlay" style="height: 100vh">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <iframe :src="gameUrl" :style="size < 960
      ? 'width: 100%; height: calc(' + this.screenHeight * 0.88 + 'px)'
      : 'width: 100%; height: calc(100vh - 93px)'
      " frameborder="0"></iframe>
    <MisCuentas />
  </div>
</template>

<script>
import axios from "axios";
import { mapActions } from "vuex";
import MisCuentas from "../components/MisCuentas.vue";
import misCuentas from "../components/MisCuentas.vue";
import verifyPromo from "../components/VerifyPromo.vue";
import VerifyTyc from "../components/VerifyTyc.vue";

export default {
  data() {
    return {
      gameUrl: null,
      overlay: true,
      isMobile: 0,
      misCuentas,
      multiplicador: 1,
      mon: null,
      screenHeight: 0
    };
  },
  watch: {
    idmoneda() {
      this.overlay = true;
      this.getGame();
    },
  },
  beforeDestroy() {
    if (typeof window === "undefined") return;
    // Removemos ambos listeners al salir del componente
    window.removeEventListener("resize", this.onResize, { passive: true });
    window.removeEventListener("message", this.handleMessage);
  },
  mounted() {
    this.screenHeight = window.innerHeight;
    this.isMobile = window.innerWidth < 600 ? 1 : 0;

    this.onResize();
    // Agregamos ambos listeners al entrar al componente
    window.addEventListener("resize", this.onResize, { passive: true });
    window.addEventListener("message", this.handleMessage);

    axios({
      method: "post",
      url: `details`,
    }).then((response) => {
      this.$store.state.nombre = response.data.success.name;
    });

    this.getSaldo();

    if (document.getElementById("fc_frame")) {
      document.getElementById("fc_frame").style.display = "none";
    }
    this.idpos = sessionStorage.getItem("idpos");
    this.getGame();
  },
  updated() {
    if (document.getElementById("fc_frame")) {
      document.getElementById("fc_frame").style.display = "none";
    }
  },
  methods: {
    ...mapActions(["getSaldo"]),

    // --- MÉTODO ACTUALIZADO CON EL FILTRO DE EXTENSIONES ---
    handleMessage(event) {
      // 1. IGNORAR MENSAJES DE EXTENSIONES CONOCIDAS (MetaMask, React DevTools, Webpack, etc.)
      if (event.data && typeof event.data === 'object') {

        if (
          event.data.source === 'react-devtools-content-script' ||
          event.data.source === 'react-devtools-bridge' ||
          event.data.source === 'vue-devtools-backend-hook' ||
          event.data.key === '__VUE_DEVTOOLS_VUE_DETECTED_EVENT__' || // Nuevo de Vue
          event.data.target === 'metamask-inpage' ||
          event.data.target === 'metamask-contentscript' ||
          event.data.type === 'webpackOk' ||
          event.data.type === 'webpackClose' ||
          event.data.type === 'webpackWarnings' ||
          event.data.type === 'webpackInvalid'
        ) {
          return;
        }
      }

      // 2. BLOQUEAR MENSAJES DE FRESHCHAT
      if (event.origin === 'https://wchat.freshchat.com') {
        return;
      }

      // 2. AHORA SÍ, IMPRIMIMOS LO QUE QUEDA (Esperamos que sea del juego)
      console.log("-----------------------------------------");
      console.log("🔔 POSIBLE MENSAJE DEL IFRAME");
      console.log("Origen:", event.origin);
      console.log("Datos:", event.data);
      console.log("-----------------------------------------");
    },

    onResize() {
      this.isMobile = window.innerWidth < 600 ? 1 : 0;
    },

    getGame() {
      const offsetHours = -new Date().getTimezoneOffset() / 60;
      this.mon = "";
      this.multiplicador = 1;

      if (this.$store.state.idmoneda == 1) {
        this.mon = "VES";
        this.multiplicador = 218;
      }
      else if (this.$store.state.idmoneda == 2) this.mon = "USD";
      else if (this.$store.state.idmoneda == 3) this.mon = "PEN";
      else if (this.$store.state.idmoneda == 7) this.mon = "COP";
      else if (this.$store.state.idmoneda == 8) this.mon = "CLP";

      axios({
        method: "post",
        url: `https://trackandraces.com/onlineapi/api/iqsoft/dev/login`,
        data: {
          moneda: this.mon,
          timezone: offsetHours
        },
      }).then((response) => {
        let url = response.data.message;

        if (this.$store.state.windowSize.x < 960) {
          try {
            let urlObj = new URL(url, window.location.origin);
            urlObj.searchParams.set("isForMobile", "true");
            url = url.startsWith('http') ? urlObj.toString() : urlObj.pathname + urlObj.search;
          } catch (e) {
            console.error("La URL proporcionada no es válida", e);
          }
        }

        this.gameUrl = url;
        this.overlay = false;
      });
    },
  },
  computed: {
    size() {
      return this.$store.state.windowSize.x;
    },
    moneda() {
      return this.$store.state.moneda;
    },
    idmoneda() {
      return this.$store.state.idmoneda;
    },
    idsb() {
      return this.$store.state.idsb;
    },
    currentBalance() {
      return this.$store.state.currentBalance;
    },
    idpos: {
      get() {
        return this.$store.state.idpos;
      },
      set(e) {
        this.$store.state.idpos = e;
      },
    },
  },
  components: { MisCuentas, verifyPromo, VerifyTyc },
};
</script>

<style>
header {
  background-color: #fa22229a;
  border-radius: 5px;
  color: #fff;
  padding: 1px;
  margin-left: 6px;
  margin-right: 6px;
  margin-bottom: 3px;
}

nav ul {
  list-style: none;
  padding: 3px;
  margin: 0;
}

nav li {
  display: inline;
  margin-right: 20px;
}

nav a {
  text-decoration: none;
  color: #fff !important;
  font-size: 16px;
}

nav a:hover {
  font-size: 17px;
  color: #000 !important;
}
</style>